import Notes from "../container/roadmap/roadmap";

export default function RoadMapRoute() {
  return <Notes />;
}
